module.exports = __webpack_public_path__ + "img/table-icon-professor.590fe683.png";